import script from "./StorySection.vue?vue&type=script&setup=true&lang=js"
export * from "./StorySection.vue?vue&type=script&setup=true&lang=js"

import "./StorySection.vue?vue&type=style&index=0&id=2306c00f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2306c00f"]])

export default __exports__